//#region MessageFilterType
export enum MessageFilterType_Enum {
  Sent = 1,
  Inbox = 2,
  Notify = 3,
}

export const MessageFilterType_Display: { [index: number]: string } = {
  [MessageFilterType_Enum.Sent]: "ارسالی ",
  [MessageFilterType_Enum.Inbox]: "دریافتی",
  [MessageFilterType_Enum.Notify]: " اعلان",
};
//#endregion
